export default "__VITE_ASSET__4249ca79__"